/**
 * pt 値を整数（カンマ区切り）で表示する。小数は四捨五入する。
 * 戦闘力（小数第1位）とは異なり、pt は全画面で整数表示に統一する。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 開発pt・戦闘力pt・実績pt などの pt 系数値を整数（カンマ区切り）に整形する共通フォーマッタ。小数を四捨五入し全画面で整数表示を統一
 * @graph-connects none
 */
export function formatPt(value: number): string {
  return Math.round(value).toLocaleString();
}
